class LpCollectionGrid extends HTMLElement {
  connectedCallback() {
    if (this.items) return;
    this.items = Array.from(this.querySelectorAll('[data-lp-page]'));
    this.pageButtons = Array.from(this.querySelectorAll('[data-page]'));
    this.prevButton = this.querySelector('[data-lp-prev]');
    this.nextButton = this.querySelector('[data-lp-next]');
    this.totalPages = this.pageButtons.length;
    this.currentPage = 1;

    if (!this.items.length || !this.pageButtons.length) return;

    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const pageButton = event.target.closest('[data-page]');
    if (pageButton) {
      this.goToPage(parseInt(pageButton.dataset.page, 10));
      return;
    }

    if (this.prevButton && event.target.closest('[data-lp-prev]')) {
      this.goToPage(this.currentPage - 1);
      return;
    }

    if (this.nextButton && event.target.closest('[data-lp-next]')) {
      this.goToPage(this.currentPage + 1);
    }
  }

  goToPage(page) {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.currentPage = page;

    this.items.forEach((item) => {
      item.hidden = item.dataset.lpPage !== String(page);
    });

    this.pageButtons.forEach((button) => {
      const isCurrent = parseInt(button.dataset.page, 10) === page;
      button.classList.toggle('pagination__item--current', isCurrent);
      if (isCurrent) {
        button.setAttribute('aria-current', 'page');
      } else {
        button.removeAttribute('aria-current');
      }
    });

    if (this.prevButton) this.prevButton.toggleAttribute('disabled', page === 1);
    if (this.nextButton) this.nextButton.toggleAttribute('disabled', page === this.totalPages);

    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

if (!customElements.get('lp-collection-grid')) customElements.define('lp-collection-grid', LpCollectionGrid);
